/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {
  addressEditRouterSegment,
  addressListRouterSegment,
  addressNewRouterSegment,
  addressRouterSegment,
  bankAccountAuditListRouterSegment,
  bankAccountListRouterSegment,
  bankAccountRouterSegment,
  changePaymentMethodRouterSegment,
  companyDashboardRouterSegment,
  companyDetailsValidationRouterSegment,
  companyPartnerPrivateRouterSegment,
  companyPartnerViewRouterSegment,
  companyRouterSegment,
  contactEditRouterSegment,
  contactListRouterSegment,
  contactNewRouterSegment,
  contactRouterSegment,
  employeeNewRouterSegment,
  employeeRouterSegment,
  myCompanyRouterSegment,
  partnerRouterSegment,
  paymentMethodPendingRouterSegment,
  profileRouterSegment,
  publicRouterSegment,
  signupContactStepSegment,
  signupPaymentInfoStepSegment,
  signupPaymentInfoStepSubscriptionTypeSegment,
  signupRouterSegment,
  signupStepSegment,
  signupSubscriptionStepSegment,
  termsAndConditionsRouterSegment
} from './company-navigation-constants';

export const partnerContactListUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, contactRouterSegment, contactListRouterSegment];
export const partnerContactNewUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, contactRouterSegment, contactNewRouterSegment];
export const partnerContactEditUrl = (bpUuid: any, uuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, contactRouterSegment, contactEditRouterSegment, uuid];

export const partnerAddressListUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, addressRouterSegment, addressListRouterSegment];
export const partnerAddressNewUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, addressRouterSegment, addressNewRouterSegment];
export const partnerAddressEditUrl = (bpUuid: any, uuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, addressRouterSegment, addressEditRouterSegment, uuid];

export const partnerBankAccountListUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, bankAccountRouterSegment, bankAccountListRouterSegment];

export const myCompanyProfileUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, profileRouterSegment];

export const myCompanyContactNewUrl = ['/', companyRouterSegment, myCompanyRouterSegment, contactRouterSegment, contactNewRouterSegment];
export const myCompanyContactEditUrl = (uuid: any) => ['/', companyRouterSegment, myCompanyRouterSegment, contactRouterSegment, contactEditRouterSegment, uuid];

export const publicContactListUrl = (bpUuid: any) => ['/', companyRouterSegment, publicRouterSegment, bpUuid, contactRouterSegment, contactListRouterSegment];

export const auditBankAccountListUrl = (uuid: any) => ['/', companyRouterSegment, myCompanyRouterSegment, bankAccountRouterSegment, bankAccountAuditListRouterSegment, uuid];

export const contactInfoSignupStepUrl = (uuid: any) => ['/', signupRouterSegment, signupStepSegment, signupContactStepSegment, uuid];
export const paymentMethodSignupStepUrl = (uuid: any, subscriptionTypeUuid: any) => ['/', signupRouterSegment, signupStepSegment, signupPaymentInfoStepSegment, uuid, signupPaymentInfoStepSubscriptionTypeSegment, subscriptionTypeUuid];
export const subscriptionSignupStepUrl = (uuid: any) => ['/', signupRouterSegment, signupStepSegment, signupSubscriptionStepSegment, uuid];

export const auditBankAccountListForPartnerUrl = (bpUuid: any, uuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, bankAccountRouterSegment, bankAccountAuditListRouterSegment, uuid];

export const changePaymentMethodUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, changePaymentMethodRouterSegment];
export const changePaymentMethodPendingUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, paymentMethodPendingRouterSegment];
export const termsAndConditionsDashboardUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, termsAndConditionsRouterSegment, companyDashboardRouterSegment]
export const addressEditUrl = (uuid: any) => ['/', companyRouterSegment, myCompanyRouterSegment, addressRouterSegment, addressEditRouterSegment, uuid];
export const addressAddUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, addressRouterSegment, addressListRouterSegment];
export const bankAccountListUrl = () => ['/', companyRouterSegment, myCompanyRouterSegment, bankAccountRouterSegment, bankAccountListRouterSegment]
export const myCompanyEmployeeNewUrl = ['/', companyRouterSegment, myCompanyRouterSegment, employeeRouterSegment, employeeNewRouterSegment];
export const termsAndConditionsUrl = ['/', termsAndConditionsRouterSegment];
export const companyDetailsValidationUrl = ['/', companyDetailsValidationRouterSegment];

export const companyPartnerViewUrl = (bpUuid: any) => ['/', companyRouterSegment, partnerRouterSegment, bpUuid, companyPartnerViewRouterSegment, companyPartnerPrivateRouterSegment];
